import * as React from 'react'
import { IWPGBlock } from 'react-gutenberg'

import HeroBlock, { getDownloadsList, IHeroAttributes } from './HeroBlock'

import { ReactBlocks } from 'app/helpers/Blocks'
import { useGlobalState } from 'app/store'

const HeroV2: React.FC<IWPGBlock> = (props) => {
  const attributes = props.attrs as IHeroAttributes

  const [blocks] = useGlobalState('reusableBlocks')
  const osButtonBlockData = blocks.get('honeygain-components/os-download-button')

  return (
    <HeroBlock
      {...attributes}
      subheadingText={<ReactBlocks innerBlocks={props.innerBlocks} withoutClientOnly />}
      downloads={getDownloadsList(attributes)}
      osButtonBlockData={osButtonBlockData}
    />
  )
}

export default HeroV2
